<template>
  <bdg-input-template
    class="bdg-checkboxes-list"
    :name="name"
    :required="required"
  >
    <checkboxes-list :options="options" v-model="computedValue" />
  </bdg-input-template>
</template>

<script>
import BdgInputTemplate from "./BdgInputTemplate";
import CheckboxesList from "./CheckboxesList";

export default {
  name: "BdgCheckboxesList",
  extends: BdgInputTemplate,
  components: { CheckboxesList, BdgInputTemplate },
  props: {
    options: Array,
    value: Array
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
